module.exports = __webpack_public_path__ + "img/l_s4.56805bb0.png";